//首页的列表
export default [
    {
        id: 17,
        title: "企业官网系统 (PC响应式布局+小程序)"
    },
    {
        id: 15,
        title: "小程序商城"
    },
    {
        id: 1,
        title: "社区团购(小程序版)"
    },{
        id: 2,
        title: "知识付费问答社区"
    },{
        id: 3,
        title: "民宿酒店预订管理系统"
    },{
        id: 4,
        title: "活动报名表单系统"
    },{
        id: 5,
        title: "优创同城跑腿小程序"
    },{
        id: 6,
        title: "小区入户安检系统"
    },{
        id: 7,
        title: "投票小程序"
    },{
        id: 8,
        title: "陪护小程序"
    },{
        id: 9,
        title: "ERP"
    },{
        id: 10,
        title: "答题考试系统"
    },{
        id: 11,
        title: "房产系统"
    },{
        id: 12,
        title: "酒店订单管理系统"
    },{
        id: 13,
        title: "赛事报名系统"
    },{
        id: 14,
        title: "球馆订场小程序"
    },{
        id: 16,
        title: "多用户电商系统"
    }
]